import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
const RATE_WINDOW = 16;
export function createLiveStore() {
    const store = createStore()(() => ({
        latestFrame: null,
        sweepRateHz: 0,
        frameCount: 0,
    }));
    // Rolling window of recent frame timestamps (external to store state to
    // avoid recomputing ring on every React selector read).
    const timestamps = [];
    function computeRate() {
        if (timestamps.length < RATE_WINDOW)
            return 0;
        const newest = timestamps[timestamps.length - 1] ?? 0;
        const oldest = timestamps[0] ?? 0;
        const spanMs = newest - oldest;
        if (spanMs <= 0)
            return 0;
        return (RATE_WINDOW - 1) / (spanMs / 1000);
    }
    const actions = {
        clear() {
            timestamps.length = 0;
            store.setState({ latestFrame: null, sweepRateHz: 0, frameCount: 0 });
        },
    };
    const internal = {
        _ingestFrame(f) {
            timestamps.push(f.timestamp);
            while (timestamps.length > RATE_WINDOW)
                timestamps.shift();
            const prev = store.getState();
            store.setState({
                latestFrame: f,
                frameCount: prev.frameCount + 1,
                sweepRateHz: computeRate(),
            });
        },
    };
    return { store, actions, internal };
}
export function useLiveStore(store, selector) {
    return useZustandStore(store, selector);
}
//# sourceMappingURL=live-store.js.map